import { clstx } from '@payaca/utilities/cvaMerge';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

const TooltipCore = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(
  (props, ref) => {
    const { className, children, ...rest } = props;

    return (
      <div
        ref={ref}
        className={clstx(
          'z-tooltip max-w-prose rounded-lg bg-gray-900 px-2 py-1 text-sm font-medium text-white shadow-sm dark:bg-gray-700',
          className
        )}
        {...rest}
      >
        {children}
      </div>
    );
  }
);

export default TooltipCore;
